import {Decimal} from 'decimal.js';

export default function(val, amount)
{
    return `€ ${new Decimal(val).mul(1 + parseFloat(amount) / 100).toFixed(4)}`;
}